import { useEffect, useState } from 'react'
import { supabase } from '@/lib/supabase'
import { useOrg } from '@/context/OrgContext'

export type Rekening = {
  id: string
  bank: string
  nomor: string
  atas_nama: string
  aktif: boolean
}

export function useRekening() {
  const { orgId, loading: orgLoading } = useOrg()
  const [rekening, setRekening] = useState<Rekening[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (orgLoading) return

    let query = supabase
      .from('rekening')
      .select('*')
      .eq('aktif', true)

    if (orgId) query = (query as any).eq('organization_id', orgId)

    query.then(({ data }) => {
      setRekening(data ?? [])
      setLoading(false)
    })
  }, [orgId, orgLoading])

  return { rekening, loading }
}
